import React from 'react';
import { Button } from '../../../components/forms/Buttons/Button';
import { landingSelect } from '../../../components/forms/Select/styles';
import Select from '../../../components/forms/Select/Select';
import { useTranslation } from 'react-i18next';
import bil_logo from '../images/bil_logo.png';
import bil_logo_kz from '../images/bil_logo_kz.png';
import bil_guys from '../images/bil_guys.png';
import mob_logo from '../images/mob_logo.png';
import bil_girl from '../images/bil_girl.png';
import { systemLanguageOptions } from '../../../components/LanguageDropdown/LanguageDropdown';
import RegistrationStatus from './RegistrationStatus';
import DateInfoBlocks from './DateInfoBlocks';

const RULES_FILE_KZ =
  'https://drive.google.com/file/d/14ngA-1evBdozOnCjvbwDYNvxmoqnj_CW/view?usp=sharing';

const RULES_FILE_RU =
  'https://drive.google.com/file/d/1rs_cyGvPWaeFsABMZwRm-ADgKE4U6Tpp/view?usp=sharing';

// PREOPEN, OPEN, PRECLOSED, CLOSED
const REGISTRATION_TYPE = 'OPEN';

const MainSection = () => {
  const [t, i18n] = useTranslation();

  function handleLanguageChange(lang) {
    i18n.changeLanguage(lang);
  }

  const rulesHref = i18n.language === 'ru' ? RULES_FILE_RU : RULES_FILE_KZ;

  return (
    <div className="flex h-screen min-h-fit  w-screen flex-col gap-4 bg-white bg-[url('pages/Landing/images/bif_logo_bg.svg')] bg-[length:85%_auto] bg-[position:50%_70%] bg-no-repeat lg:bg-[length:auto_75%] lg:bg-[position:3%_80%]">
      {/* Desktop version */}
      <div className='hidden flex-col lg:flex'>
        {/* Header */}
        <div className='mt-10 flex flex-row items-center justify-around gap-12'>
          <img
            src={i18n.language === 'ru' ? bil_logo : bil_logo_kz}
            alt='Bil logo'
            className='h-[3.875rem] w-[13.3rem]'
          />
          <div className='flex flex-row items-center gap-4'>
            <Select
              className='w-40 text-center'
              customStyles={landingSelect}
              isSearchable={false}
              value={i18n.language}
              options={systemLanguageOptions}
              onChange={(e) => handleLanguageChange(e.value)}
            />
            <a href={rulesHref} target='_blank' rel='noreferrer'>
              <Button
                className='rounded-xl'
                color='landing-blue'
                text={t('welcome.entrace_rules')}
              />
            </a>
          </div>
        </div>

        {/* Hero section */}
        <div className='mt-20 ml-28 flex flex-row items-end justify-center gap-8'>
          <img
            height={243}
            width={151}
            src={bil_girl}
            alt='bil student'
          />
          <div className='flex flex-col justify-center gap-4 px-3 sm:px-0'>
            <div className='w-full px-3 pb-4 font-sfproBold text-4xl sm:px-0 sm:text-5xl'>
              <p>{t('welcome.enter_exam_to_bil_1')}</p>
              <p>"Білім-инновация"</p>
              <p>{t('welcome.enter_exam_to_bil_2')}</p>
            </div>
            <DateInfoBlocks />
          </div>
        </div>

        {/* Registration status */}
        <div className='ml-80 flex flex-row items-start justify-center py-4'>
          <div className='flex flex-col items-center'>
            <div className='flex flex-col justify-center gap-4 px-3 sm:px-0'></div>

            <div className='mt-4 flex w-full -translate-x-12 flex-row justify-between'>
              <div>{/* не трогать это важная заглушка */}</div>

              <div className='flex flex-col items-start px-3 '>
                <RegistrationStatus
                  registrationType={REGISTRATION_TYPE}
                  variant='desktop'
                />
              </div>
              <div>{/* не трогать это важная заглушка */}</div>
            </div>
          </div>
          <img
            className='-translate-y-12 -translate-x-4'
            width={254}
            height={289}
            src={bil_guys}
            alt='2 bil student'
          />
        </div>
      </div>

      {/* Mobile version */}
      <div className='mt-5 flex flex-col gap-5 lg:hidden'>
        {/* Mobile header */}
        <div className='flex flex-row justify-between px-6'>
          <img src={mob_logo} alt='logo' width={49} height={43} />
          <Select
            className='z-30 w-48 text-center'
            customStyles={landingSelect}
            isSearchable={false}
            value={i18n.language}
            options={systemLanguageOptions}
            onChange={(e) => handleLanguageChange(e.value)}
          />
        </div>
        <div className='flex -translate-y-5 flex-row justify-end px-6'>
          <a href={rulesHref} target='_blank' rel='noreferrer'>
            <Button
              className='w-48 rounded-xl'
              color='landing-blue'
              text={t('welcome.entrace_rules')}
            />
          </a>
        </div>

        {/* Mobile photo */}
        <div className='flex flex-row items-end justify-end px-8 '>
          <img src={bil_girl} width='93' height={151} alt='bil student' />
        </div>

        {/* Mobile hero */}
        <div className='flex flex-col justify-center gap-4 px-3 sm:px-0'>
          <div className='w-full px-3 pb-4 font-sfproBold text-2xl sm:px-0 sm:text-5xl'>
            <p>{t('welcome.enter_exam_to_bil_1')}</p>
            <p className='keep- break-keep'>"Білім-инновация"</p>
            <p>{t('welcome.enter_exam_to_bil_2')}</p>
          </div>
          <DateInfoBlocks />
        </div>

        {/* Mobile registration status */}
        <div className='flex flex-col items-center gap-3 text-center'>
          <RegistrationStatus
            registrationType={REGISTRATION_TYPE}
            variant='mobile'
          />
        </div>
        <div>{/* не трогать это важная заглушка */}</div>
      </div>
    </div>
  );
};

export default MainSection;
